<template>
  <div class="custom-skeleton">
    <AtomicUiSkeleton :width="width" :height="height" />
  </div>
</template>

<script setup>
defineProps({
  width: {
    type: String,
    default: '98%',
  },
  height: {
    type: String,
    default: '12.5rem',
  },
});
</script>
